import { render, staticRenderFns } from "./CommunityPostToolbar.vue?vue&type=template&id=5cc05192&scoped=true&"
import script from "./CommunityPostToolbar.vue?vue&type=script&lang=js&"
export * from "./CommunityPostToolbar.vue?vue&type=script&lang=js&"
import style0 from "./CommunityPostToolbar.vue?vue&type=style&index=0&id=5cc05192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc05192",
  null
  
)

export default component.exports